import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import SideMenu from "../../Components/SideMenu";
import {
  exportedFilesDelete,
  exportedOrderList,
  exportOrderDateWise,
} from "../../reducers/commonReducer";
import { handleDownload, home } from "../../const";
import { Button, Col, Row } from "react-bootstrap";

const validationSchema = Yup.object().shape({
  startDate: Yup.date().required("Start Date is required"),
  endDate: Yup.date()
    .required("End Date is required")
    .min(Yup.ref("startDate"), "End Date cannot be before Start Date"),
});
const ExportOrderList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (
      localStorage.getItem("slug") === "admin"
        ? !localStorage.getItem("x-admin-token")
        : !localStorage.getItem("x-auth-token")
    ) {
      navigate(home);
    }
    dispatch(exportedOrderList());
  }, []);
  //delete order pdf
  const deleteRecord = async () => {
    const apiResp = await dispatch(exportedFilesDelete());
    if (apiResp?.payload?.status) {
      dispatch(exportedOrderList());
    }
  };
  const { exportedOrderRecord } = useSelector((state) => state.commonReducer);
  return (
    <>
      <SideMenu />
      <div className="mt-extra content container-fluid">
        <Row>
          <Col md={10}>
            <Formik
              initialValues={{
                startDate: "",
                endDate: "",
              }}
              validationSchema={validationSchema}
              onSubmit={async (values, { setSubmitting }) => {
                setLoading(true);
                try {
                  await dispatch(exportOrderDateWise(values));
                } catch (error) {
                  console.error("Export failed:", error);
                } finally {
                  setLoading(false);
                  setSubmitting(false);
                  window.alert("Exported successfully. Please refresh the page after 5 minutes.");
                  dispatch(exportedOrderList());
                }
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form noValidate onSubmit={handleSubmit}>
                  <Row>
                    <Col md={3} sm={12}>
                      <Form.Group controlId="startDate">
                        <Form.Label>Start Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={values.startDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.startDate && !!errors.startDate}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.startDate}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={3} sm={12}>
                      <Form.Group controlId="endDate">
                        <Form.Label>End Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={values.endDate}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.endDate && !!errors.endDate}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.endDate}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={2} className="mt-4">
                      <Button
                        variant="warning"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />{" "}
                            Exporting...
                          </>
                        ) : (
                          "Export Orders"
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
          <Col md={2}>
            <Button
              onClick={deleteRecord}
              variant="danger"
              className="float-right"
            >
              Delete <i className="bi bi-trash3-fill"></i>
            </Button>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={12}>
            <h3 className="text-black mt-3">
              <b>Exported Orders</b>
            </h3>
          </Col>
          <Row>
            {exportedOrderRecord?.files?.map((files, fileIndex) => {
              return (
                <Col md={3} key={fileIndex}>
                  <Button
                    onClick={() => window.open(files, '_blank')}
                    className="w-100 theme-btn py-4 word-wrap-break mb-2"
                  >
                    {files.substring(files.lastIndexOf("/") + 1)}
                  </Button>
                </Col>
              );
            })}
          </Row>
        </Row>
      </div>
    </>
  );
};

export default ExportOrderList;
